import { AlertBannerComponent } from './alert-banner.component';

export const AlertBannerModule = angular
  .module('sfMobile.components.alert-banner', [])
  .component('sfAlertBanner', AlertBannerComponent).name;
